import React, { useEffect, useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import PropTypes from 'prop-types';
import LoadingPage from '../LoadingPage';
import ApiService from '../../services/ApiService';
import ModalTable from './ModalTable';
import SectionHeading from './SectionHeading';
import CurrencyItem from '../form/misc/CurrencyItem';

const estimateHeaders = [
  {
    text: 'Estimate',
    helper: 'viewInvoice',
  },
  {
    text: 'Amount',
    type: 'currencyColumn',
    className: 'right',
  },
];

const repairOrderHeaders = [
  {
    text: 'Repair Order',
    helper: 'viewInvoice',
  },
  {
    text: 'Amount',
    type: 'currencyColumn',
    className: 'right',
  },
];


const priorYearHeaders = [
  {
    text: 'Year',
    className: 'center',
  },
  {
    text: 'Parts',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'Service',
    type: 'currencyColumn',
    className: 'right',
  },
];

const ytdHeaders = [
  {
    text: 'Month',
  },
  {
    text: 'Balance',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'Pay Days',
    type: 'numberColumn',
    className: 'right',
  },
  {
    text: 'Part Sales',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'Part Cnt',
    type: 'numberColumn',
    className: 'right',
  },
  {
    text: 'Avg Sale',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'Credits',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'Credit Cnt',
    type: 'numberColumn',
    className: 'right',
  },
  {
    text: 'RO Sales',
    type: 'currencyColumn',
    className: 'right',
  },
  {
    text: 'RO Cnt',
    type: 'numberColumn',
    className: 'right',
  },
  {
    text: 'RO Avg Sale',
    type: 'currencyColumn',
    className: 'right',
  },
];

const todayInvoiceHeaders = [
  {
    text: 'Invoice',
    helper: 'viewInvoice',
  },
  {
    text: 'Amount',
    type: 'currencyColumn',
    className: 'right',
  },
];

const CustomerHistoryAR = ({ lookupKey, view }) => {
  const [loading, setLoading] = useState(true);
  const [primaryData, setPrimaryData] = useState({});
  const [historyHeaders, setHistoryHeaders] = useState({});

  const getData = () => {
    setLoading(true);

    ApiService.get(`drilldown/${view}/${encodeURIComponent(lookupKey)}`).then(response => {
      const { data } = response.data;

      const specs = JSON.parse(data);

      // Current years sales
      specs.yearToDateSales = specs.yearToDateSales.map(r => Object.keys(r).map(k => r[k]));

      // Past 4 years history
      setHistoryHeaders(Object.keys(specs.salesHistory[0]));
      specs.salesHistory = specs.salesHistory.map(r => Object.keys(r).map(k => r[k]));

      // recent invoices
      specs.recentInvoices = specs.recentInvoices.map(r => Object.keys(r).map(k => r[k]));

      // recent repair orders
      specs.recentRepairOrders = specs.recentRepairOrders.map(r => Object.keys(r).map(k => r[k]));

      // recent estimates
      specs.recentEstimates = specs.recentEstimates.map(r => Object.keys(r).map(k => r[k]));

      setPrimaryData(specs);
      setLoading(false);
    });
  };

  useEffect(() => {
    getData();
  }, []);

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div>
      <Row>
        <Col md={12}>
          <SectionHeading>Customer Details</SectionHeading>
          {/* <ModalList data={primaryData.customerDetails} columns={2} /> */}

          <Row className="mr-0 ml-0 mb-1">
            {Object.keys(primaryData.customerDetails).map(key => {
              return (
                <Col sm={6} className="p-0 d-inline-flex" key={key}>
                  <Col sm={6} className="p-0">
                    <div className="p-1 m-1 text-bold" style={{ borderBottom: '1px solid var(--primary-color)' }}>
                      {key}
                    </div>
                  </Col>
                  <Col sm={6} className="p-0 text-right">
                    <div className="p-1 m-1" style={{ backgroundColor: '#fafafa', borderBottom: '1px dotted #ccc' }}>
                      {primaryData.customerDetails[key]}
                    </div>
                  </Col>
                </Col>
              );
            })}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={6}>
          <SectionHeading>Balances</SectionHeading>
          <Row className="mr-0 ml-0 mb-1">
            {Object.keys(primaryData.balances).map(key => {
              return (
                <React.Fragment key={key}>
                  <Col sm={3} className="p-0">
                    <div
                      className="p-1 m-1 text-bold"
                      style={{ borderBottom: '1px solid var(--primary-color)' }}
                    >
                      {key}
                    </div>
                  </Col>
                  <Col sm={3} className="p-0 text-right">
                    <div className="p-1 m-1" style={{ backgroundColor: '#fafafa', borderBottom: '1px dotted #999' }}>
                      <CurrencyItem>{primaryData.balances[key]}</CurrencyItem>
                    </div>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </Col>
        <Col md={6}>
          <SectionHeading>Activity</SectionHeading>
          <Row className="mr-1 ml-1 mb-2">
            {Object.keys(primaryData.activity).map(key => {
              return (
                <React.Fragment key={key}>
                  <Col sm={3} className="p-0">
                    <div
                      className="p-1 m-1 text-bold"
                      style={{ borderBottom: '1px solid var(--primary-color)' }}
                    >
                      {key}
                    </div>
                  </Col>
                  <Col sm={3} className="p-0 text-right">
                    <div className="p-1 m-1" style={{ backgroundColor: '#fafafa', borderBottom: '1px dotted #999' }}>
                      {primaryData.activity[key]}
                    </div>
                  </Col>
                </React.Fragment>
              );
            })}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <SectionHeading>Year To Date</SectionHeading>
          <ModalTable hideToolbar headers={ytdHeaders} data={primaryData.yearToDateSales} style={{ height: '420px' }} />
        </Col>
      </Row>

      <Row>
        <Col md={12}>
          <SectionHeading>Prior Years</SectionHeading>
          <ModalTable
            hideToolbar
            headers={priorYearHeaders}
            data={primaryData.salesHistory}
            style={{ height: '165px' }}
          />
        </Col>
      </Row>

      <Row>
        <Col md={4}>
          <SectionHeading>Today's Part Invoices</SectionHeading>
          <ModalTable hideToolbar headers={todayInvoiceHeaders} data={primaryData.recentInvoices} />
        </Col>
        <Col md={4}>
          <SectionHeading>Today's Repair Orders</SectionHeading>
          <ModalTable hideToolbar headers={repairOrderHeaders} data={primaryData.recentRepairOrders} />
        </Col>

        <Col md={4}>
          <SectionHeading>Estimates</SectionHeading>
          <ModalTable hideToolbar headers={estimateHeaders} data={primaryData.recentEstimates} />
        </Col>
      </Row>
    </div>
  );
};

CustomerHistoryAR.propTypes = {
  lookupKey: PropTypes.string,
  view: PropTypes.string,
};

export default CustomerHistoryAR;
